interface ISearchResultsRoute {
  operation: string
  lat: number
  lng: number
  propertyTypes: string[]
  sharesCommission: boolean
  fullAddress: string
  priceTo: number
  searchLevel: string
}

interface IGenerateDetailRoute {
  isWiggotProperty?: boolean
  wiggotMetadata?: { [key: string]: any }
  itemId: string
}

const baseEncodeParams = ({
  fullAddress,
  priceTo,
  propertyTypes,
  sharesCommission,
  operation,
  lat,
  lng,
  searchLevel
}: ISearchResultsRoute) => {
  const params = []

  if (fullAddress) {
    params.push(`search=${encodeURIComponent(fullAddress)}`)
  }
  if (searchLevel) {
    params.push(`searchLevel=${encodeURIComponent(searchLevel)}`)
  }
  params.push(
    `priceFrom=0&priceTo=${encodeURIComponent(priceTo ? priceTo : 1)}`
  )
  if (propertyTypes) {
    params.push(
      `constructionType=${propertyTypes
        .map((type) => encodeURIComponent(type))
        .join(',')}`
    )
  }
  if (sharesCommission) {
    params.push(`sharesCommision=${encodeURIComponent(sharesCommission)}`)
  }
  if (operation) {
    params.push(`operation=${encodeURIComponent(operation)}`)
  }
  if (lat) {
    params.push(`lat=${encodeURIComponent(lat)}`)
  }
  if (lng) {
    params.push(`lng=${encodeURIComponent(lng)}`)
  }

  return params.length > 0 ? `?${params.join('&')}` : ''
}

export const SEARCH_RESULTS_ROUTE = ({
  operation,
  lat,
  lng,
  propertyTypes,
  sharesCommission,
  fullAddress,
  priceTo,
  searchLevel
}: ISearchResultsRoute) => {
  return `/search/results${baseEncodeParams({
    fullAddress,
    priceTo,
    propertyTypes,
    sharesCommission,
    operation,
    lat,
    lng,
    searchLevel
  })}`
}

export const generateDetailRoute = ({
  isWiggotProperty,
  wiggotMetadata,
  itemId
}: IGenerateDetailRoute) => {
  if (isWiggotProperty) {
    const { externalId = '' } = wiggotMetadata || {}

    const wiggotId = externalId?.split('_')[0] || []

    return window.open(`/search/property-detail/${wiggotId}`, '_blank')
  }
  return window.open(`/search/property-detail/${itemId}`, '_blank')
}

export const setNewQueryParams = (params: { [key: string]: any }) => {
  if (window) {
    const queryParams = new URLSearchParams(window.location.search)
    Object.keys(params).forEach((key) => {
      if (params[key]) {
        queryParams.set(key, params[key])
      } else {
        queryParams.delete(key)
      }
    })
    window.history.replaceState(
      {},
      '',
      `${window.location.pathname}?${queryParams}`
    )
  }
}
